// Page List Without Footer Navigation
const hideLanguageSelectorPageList = [
  "payment",
  "es/payment",
  "en-US/payment",
  "review/new-passport",
  "review/passport-renewal",
  "review/lost-stolen-passport",
  "review/passport-corrections",
];

export default hideLanguageSelectorPageList;
